import React from 'react';
import { Link } from 'react-router-dom';

export const BrandCard = ({ brand, categorySlug }) => {
  // Category context → brand-in-category page; otherwise global brand catalog
  const brandUrl = categorySlug
    ? `/category/${categorySlug}/brand/${brand.slug}`
    : `/brand/${brand.slug}`;

  return (
    <Link
      to={brandUrl}
      className="group block p-6 bg-white border border-gray-100 hover:border-[#C0C4CC]/30 transition-all duration-300"
      data-testid={`brand-card-${brand.slug}`}
    >
      <div className="flex items-center justify-center h-20">
        {brand.logo ? (
          <img
            src={brand.logo}
            alt={brand.name}
            className="max-h-full max-w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
          />
        ) : (
          <span className="text-lg font-medium text-[#0A0A0A] group-hover:text-[#C0C4CC] transition-colors">
            {brand.name}
          </span>
        )}
      </div>
    </Link>
  );
};

export default BrandCard;
